const SkeletonLoader = () => {
  return (
    <div className="cy:bg-white cy:rounded-lg cy:shadow-sm">
      {/* Header */}
      <div className="cy:border-b cy:border-gray-200 cy:pb-6 cy:p-6">
          <div className="cy:h-6 cy:bg-gray-200 cy:rounded cy:w-48 cy:mb-2 cy:animate-pulse"></div>
          <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-96 cy:animate-pulse"></div>
        </div>

        {/* Content */}
        <div className="cy:p-6">
          <div className="cy:flex cy:flex-col cy:gap-4">
            {/* Readability Category */}
            <div className="cy:grid cy:grid-cols-20 cy:border cy:border-[#EAEBEC] cy:rounded-xs">
              <div className="cy:col-span-4 cy:bg-[#EAEBEC] cy:flex cy:items-center cy:justify-start cy:py-4 cy:px-4">
                <div className="cy:h-4 cy:bg-gray-300 cy:rounded cy:w-20 cy:animate-pulse"></div>
              </div>
              <div className="cy:col-span-16 cy:bg-white cy:p-4 cy:space-y-6">
                <div className="cy:flex cy:items-center cy:justify-between">
                  <div className="cy:flex-1 cy:pl-4">
                    <div className="cy:flex cy:items-center cy:justify-start cy:space-x-5">
                      <div className="cy:w-4.5 cy:h-4.5 cy:bg-gray-200 cy:rounded-[2px] cy:border-2 cy:border-[#49454F] cy:animate-pulse"></div>
                      <div className="cy:flex cy:flex-col">
                        <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-64 cy:mb-1 cy:animate-pulse"></div>
                        <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-80 cy:animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                  <div className="cy:ml-4">
                    <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-16 cy:animate-pulse"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Keyboard Navigation Category */}
            <div className="cy:grid cy:grid-cols-20 cy:border cy:border-[#EAEBEC] cy:rounded-xs">
              <div className="cy:col-span-4 cy:bg-[#EAEBEC] cy:flex cy:items-center cy:justify-start cy:py-4 cy:px-4">
                <div className="cy:h-4 cy:bg-gray-300 cy:rounded cy:w-32 cy:animate-pulse"></div>
              </div>
              <div className="cy:col-span-16 cy:bg-white cy:p-4 cy:space-y-6">
                {/* First option */}
                <div className="cy:flex cy:items-center cy:justify-between">
                  <div className="cy:flex-1 cy:pl-4">
                    <div className="cy:flex cy:items-center cy:justify-start cy:space-x-5">
                      <div className="cy:w-4.5 cy:h-4.5 cy:bg-gray-200 cy:rounded-[2px] cy:border-2 cy:border-[#49454F] cy:animate-pulse"></div>
                      <div className="cy:flex cy:flex-col">
                        <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-72 cy:mb-1 cy:animate-pulse"></div>
                        <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-80 cy:animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                  <div className="cy:ml-4">
                    <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-16 cy:animate-pulse"></div>
                  </div>
                </div>

                {/* Second option */}
                <div className="cy:flex cy:items-center cy:justify-between">
                  <div className="cy:flex-1 cy:pl-4">
                    <div className="cy:flex cy:items-center cy:justify-start cy:space-x-5">
                      <div className="cy:w-4.5 cy:h-4.5 cy:bg-gray-200 cy:rounded-[2px] cy:border-2 cy:border-[#49454F] cy:animate-pulse"></div>
                      <div className="cy:flex cy:flex-col">
                        <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-48 cy:mb-1 cy:animate-pulse"></div>
                        <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-80 cy:animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                  <div className="cy:ml-4">
                    <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-16 cy:animate-pulse"></div>
                  </div>
                </div>

                {/* Input field */}
                <div className="cy:mt-4 cy:pl-14">
                  <div className="cy:max-w-md">
                    <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-64 cy:mb-2 cy:animate-pulse"></div>
                    <div className="cy:h-20 cy:bg-gray-100 cy:border cy:border-gray-300 cy:rounded-md cy:animate-pulse"></div>
                    <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-80 cy:mt-1 cy:animate-pulse"></div>
                  </div>
                </div>

                {/* Third option */}
                <div className="cy:flex cy:items-center cy:justify-between">
                  <div className="cy:flex-1 cy:pl-4">
                    <div className="cy:flex cy:items-center cy:justify-start cy:space-x-5">
                      <div className="cy:w-4.5 cy:h-4.5 cy:bg-gray-200 cy:rounded-[2px] cy:border-2 cy:border-[#49454F] cy:animate-pulse"></div>
                      <div className="cy:flex cy:flex-col">
                        <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-56 cy:mb-1 cy:animate-pulse"></div>
                        <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-80 cy:animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                  <div className="cy:ml-4">
                    <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-16 cy:animate-pulse"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* More categories - simplified */}
            {[...Array(5)].map((_, i) => (
              <div key={i} className="cy:grid cy:grid-cols-20 cy:border cy:border-[#EAEBEC] cy:rounded-xs">
                <div className="cy:col-span-4 cy:bg-[#EAEBEC] cy:flex cy:items-center cy:justify-start cy:py-4 cy:px-4">
                  <div className="cy:h-4 cy:bg-gray-300 cy:rounded cy:w-24 cy:animate-pulse"></div>
                </div>
                <div className="cy:col-span-16 cy:bg-white cy:p-4 cy:space-y-6">
                  <div className="cy:flex cy:items-center cy:justify-between">
                    <div className="cy:flex-1 cy:pl-4">
                      <div className="cy:flex cy:items-center cy:justify-start cy:space-x-5">
                        <div className="cy:w-4.5 cy:h-4.5 cy:bg-gray-200 cy:rounded-[2px] cy:border-2 cy:border-[#49454F] cy:animate-pulse"></div>
                        <div className="cy:flex cy:flex-col">
                          <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-60 cy:mb-1 cy:animate-pulse"></div>
                          <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-72 cy:animate-pulse"></div>
                        </div>
                      </div>
                    </div>
                    <div className="cy:ml-4">
                      <div className="cy:h-3 cy:bg-gray-100 cy:rounded cy:w-16 cy:animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Save button */}
          <div className="cy:py-2 cy:mt-6">
            <div className="cy:h-10 cy:bg-gray-200 cy:rounded cy:w-32 cy:animate-pulse"></div>
          </div>
        </div>
      </div>
  );
};

export default SkeletonLoader;